import { WALLET_TERMS_AND_CONDITIONS_LINKS } from 'constants/wallet';
import { AMPLITUDE_WALLET_PROPERTY_VALUES } from 'constants/amplitude';

export const getWalletTermsUrl = country =>
  WALLET_TERMS_AND_CONDITIONS_LINKS[country] || WALLET_TERMS_AND_CONDITIONS_LINKS.default;

export const formatPresetAmount = (amount, symbol) => `${symbol}${amount.toLocaleString()}`;

const isBlankAmount = value => value === null || value === undefined || value === '';

// A typed "other" amount wins over the presets (see LowBalanceAlert)
export const getLowBalanceInputMethod = otherAmount =>
  isBlankAmount(otherAmount)
    ? AMPLITUDE_WALLET_PROPERTY_VALUES.inputMethod.preset
    : AMPLITUDE_WALLET_PROPERTY_VALUES.inputMethod.custom;

export const toMinorUnits = amount => Math.round(Number(amount) * 100);

export const buildCreateWalletPayload = ({
  walletName,
  lowBalanceAlertAmount,
  termsAndConditions,
}) => ({
  walletName,
  termsAndConditionsAccepted: !!termsAndConditions,
  lowBalanceAlertThresholdMinor: toMinorUnits(lowBalanceAlertAmount),
});
